
export { getDomain } from "/vercel/path0/packages/@jog/shared/src/helper.ts"